import React, { Component } from 'react';
import * as d3 from 'd3';

const minyear = {sydney: 1991, auckland: 1980, vancouver: 1980}
const maxyear = {sydney: 2018, auckland: 2018, vancouver: 2019}
const continents = ["Oceania", "Europe", "Asia", "Americas", "Africa"];

const tickValues = {
    vancouver: [1980, 1990, 2000, 2010, 2018],
    auckland: [1980, 1990, 2000, 2010, 2017],
    sydney: [1991, 2000, 2010, 2017]
}

export default class OriginArea extends Component {
    constructor(props) {
        super(props);
        this.state = {};

        d3.json("data/national/" + this.props.city + "/timeseries.json").then((data) => {
            this.setState({data: data});
        });
    }

    componentDidUpdate() {
        if (this.state.data) {
            if (d3.selectAll("#maing" + this.props.city)._groups[0].length == 0) {
                this.createStackedArea();
            } else {
                this.updateStackedArea();
            }
        }
    }

    updateStackedArea() {
        const height = this.props.height;
        const width = this.props.width;
        let margin = {top: 0, right: 30, bottom: 30, left: 30};

        const yScale = d3.scaleLinear().domain([1, 0]).range([height - margin.top - margin.bottom, 0]);
        const xScale = d3.scaleLinear().domain([minyear[this.props.city], maxyear[this.props.city]]).range([0, width - margin.left - margin.right]);
        
        let area = d3.area().curve(d3.curveLinear)
            .x((d) => xScale(d.data.year))
            .y0((d) => yScale(d[0]))
            .y1((d) => yScale(d[1]));

        this.areas.attr("d", d => area(d));

        d3.select(".axis--x-mini-" + this.props.city)
            .call(d3.axisBottom(xScale).tickFormat(x => x).tickValues(tickValues[this.props.city]));

        d3.selectAll(".axis--x-mini-" + this.props.city).selectAll(".tick").selectAll("line").remove();
        d3.selectAll(".axis--x-mini-" + this.props.city).selectAll(".domain").remove();
    }

    createStackedArea() {
        const svg = d3.select(this.node);
        const height = this.props.height;
        const width = this.props.width;
        let margin = {top: 0, right: 30, bottom: 30, left: 30};

        const yScale = d3.scaleLinear().domain([1, 0]).range([height - margin.top - margin.bottom, 0]);
        const xScale = d3.scaleLinear().domain([minyear[this.props.city], maxyear[this.props.city]]).range([0, width - margin.left - margin.right]);
        this.g = svg.selectAll("g").data([1]).enter().append("g").attr("id", "maing" + this.props.city).attr("transform", "translate(" + margin.left + "," + margin.top + ")");
        this.areas = {};
        this.outlines = {};

        const data = this.state.data.map(d => {
            let sum = 0;
            for (let i = 0; i < continents.length; i++) {
                sum += d[continents[i]];
            }

            for (let i = 0; i < continents.length; i++) {
                d[continents[i]] = d[continents[i]]/sum;
            }

            return d;
        })

        let stack = d3.stack().keys(continents);
        // let filtered = JSON.parse(JSON.stringify(this.state.data.filter((d) => d.year === year || d.year === year + 1 || d.year === year - 1)));
        let mode = 'real';
            
        let stackedData = stack(data);

        let scheme = d3.scaleOrdinal([d3.interpolateViridis(0), d3.interpolateViridis(0.175), d3.interpolateViridis(0.35), d3.interpolateViridis(0.525), d3.interpolateViridis(0.7)]);

        let area = d3.area().curve(d3.curveLinear)
            .x((d) => xScale(d.data.year))
            .y0((d) => yScale(d[0]))
            .y1((d) => yScale(d[1]));

        this.categories = this.g.append("g").selectAll(".categories")
            .data(stackedData)
            .enter().append("g")
                .attr("class", "continents");

        this.areas = this.categories.append("path")
            .attr("class", "area")
            .attr("d", d => area(d))
            .style("fill", d => scheme(d.key))
            .style("stroke", d => scheme(d.key))
            .style("stroke-width", "1px");

        if (d3.selectAll(".axis--x-mini-" + this.props.city)._groups[0].length == 0) {
            this.xAxis = this.g.append("g")
                .attr("class", "axis axis--x-mini-" + this.props.city)
                .style("font-size", "14px")
                .attr("transform", "translate(0," + (height - margin.bottom - margin.top) + ")")
                .call(d3.axisBottom(xScale).tickFormat(x => x).tickValues(tickValues[this.props.city]));

            d3.selectAll(".axis--x-mini-" + this.props.city).selectAll(".tick").selectAll("line").remove();
            d3.selectAll(".axis--x-mini-" + this.props.city).selectAll(".domain").remove();
        }
    }
 
    render() {
        return <svg height={this.props.height} width={this.props.width} ref={node => this.node = node} />
    }
}


// WEBPACK FOOTER //
// ./src/OriginArea/OriginArea.jsx